/* eslint-disable react-hooks/immutability */
"use client";

import { ReactNode } from "react";
import { OpenAPI } from "@/generated/core/OpenAPI";

interface Props {
  children: ReactNode;
}

export function OpenAPIProvider({ children }: Props) {
  OpenAPI.BASE = process.env.NEXT_PUBLIC_API_URL || "";
  OpenAPI.HEADERS = {
    "ocp-apim-subscription-key": process.env.NEXT_PUBLIC_SUBSCRIPTION_KEY || "",
  };

  OpenAPI.TOKEN = async () => {
    const globalStoreToken = localStorage.getItem("global-store");
    if (globalStoreToken) {
      const parsedStore = JSON.parse(globalStoreToken);
      if (parsedStore?.state && parsedStore.state.accessToken) {
        return parsedStore.state.accessToken;
      }
    }
    return "";
  };
  return <>{children}</>;
}
